<template>
  <div :style="`width: ${width};`" :class="'py-4 fin-strategy-instruments-data-table' + ($vuetify.breakpoint.xs ? ' pt-2' : '')">

    <fin-dynamic-etf-filter
      v-if="assetClassId !== 'SHARE'"
      :hide-filter="hideFilter"
      :hide-crypto="hideCrypto"
      :etf-filter-class="strategy.id"
      :ignore-default-filters="($route.path.includes('/finStrategy/') && !$route.path.includes('/finStrategist')) || $route.path.includes('/myFinHub/')"
      @input="val => activeEtfFilters = val.activeFilters">
      <div class="mt-10">
        <fin-dropdown v-if="extendedView"
                      :dropdown-height="dropdownHeight"
                      :items="extendedViewViewDropdown"
                      :value="viewType"
                      check-attribute="title"
                      label="Ansicht"
                      show-selection
                      single-select/>

        <fin-data-table v-model="selected"
                        ref="finDataTable"
                        :headers="headers"
                        :height="tableHeight"
                        :item-key="'instrumentId'"
                        :resolver="resolver"
                        :show-select="showSelect"
                        :sort-by="sortByDefault"
                        :sort-desc="sortDescDefault"
                        class="my-3"
                        fixed-header/>

        <v-row align="center" justify="center" no-gutters ref="footerActionsRow">
          <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="5">
            <v-switch
              v-model="extendedView"
              class="switch d-inline-block"
              hide-details
              inset
            />
            <span class="label pr-3 align-center" style="font-size: 14px; font-weight: bold;">Erweiterte Ansicht </span>
          </v-col>
          <v-col align="right" cols-md="7">
            <slot name="footer-actions"/>
          </v-col>
        </v-row>
      </div>
    </fin-dynamic-etf-filter>

    <template v-else>
      <fin-dropdown v-if="extendedView"
                    :dropdown-height="dropdownHeight"
                    :items="extendedViewViewDropdown"
                    :value="viewType"
                    check-attribute="title"
                    label="Ansicht"
                    show-selection
                    single-select/>

      <fin-data-table v-model="selected"
                      ref="finDataTable"
                      :headers="headers"
                      :height="tableHeight"
                      :item-key="'instrumentId'"
                      :resolver="resolver"
                      :show-select="showSelect"
                      :sort-by="sortByDefault"
                      :sort-desc="sortDescDefault"
                      class="my-3"
                      :native-scroll="nativeScroll"
                      fixed-header/>

      <v-row align="center" justify="center" no-gutters ref="footerActionsRow">
        <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="5">
          <v-switch
            v-model="extendedView"
            class="switch d-inline-block"
            hide-details
            inset
          />
          <span class="label pr-3 align-center" style="font-size: 14px; font-weight: bold;">Erweiterte Ansicht </span>
        </v-col>
        <v-col align="right" cols-md="7">
          <slot name="footer-actions"/>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import FinDataTable from "@/components/common/DataTable/FinDataTable"
import FinDropdown from "@/components/common/Dropdown"
import {finInstrumentAPI} from "@/js/finAPI"
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"
import FinDynamicEtfFilter from "@/components/common/Strategy/DynamicEtfFilter"
import etfFilterBuilder from "@/components/common/Strategy/DynamicEtfFilter/etfFilterBuilder"
import SubscriptionHandler from "@/mixins/SubscriptionHandler"
import {strategyDetailsInstrumentSubscription} from "@/js/finSubscriptions"
import Cryptocurrencies from "@/mocks/Cryptocurrencies"

//https://lowrey.me/create-an-object-by-path-in-javascript-2/
const createPath = (obj, path, value = null) => {
  path = typeof path === 'string' ? path.split('.') : path
  let current = obj
  while (path.length > 1) {
    const [head, ...tail] = path
    path = tail
    if (current[head] === undefined) {
      current[head] = {}
    }
    current = current[head]
  }
  current[path[0]] = value
  return obj
}

export default {
  name: 'fin-strategy-instruments-data-table',
  components: {FinDynamicEtfFilter, FinDataTable, FinDropdown},
  props: {
    /** selected instruments */
    value: {
      type: Array
    },
    /** Share or ETFs-asset class*/
    assetClassId: {
      type: String,
      default: undefined
    },
    /** strategy */
    strategy: {
      type: Object,
      default: undefined
    },
    /** share universe */
    shareUniverse: {
      type: Array,
      default: undefined
    },
    loading: {
      type: Boolean
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    tableHeight: {
      type: String,
      default: undefined
    },
    /** allowed values: "link" and "dialog".
     * "link" to display the instrument as a link to the instrument page.
     * "dialog" to open a dialog, if the user clicks on the instrument's name */
    showInstrumentProfileAs: {
      type: String,
      default: undefined
    },
    width: {
      type: String,
      default: undefined
    },
    nativeScroll: {
      type: Boolean
    },
    /**
     * If realTime-subscription shall be turned on or off
     */
    realtime: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      currentPage: -1,
      selected: this.value ? this.value.slice(0) : [],
      isMobile: false,
      sortByDefault: ["finScore"],
      sortDescDefault: [true],
      viewType: [{title: "Überblick"}],
      assetClassDropdownMapping: [
        {
          assetClassId: 'SHARE',
          extendedViewViewDropdown: [
            {title: "Überblick"} /*,
            {title: "Aktienbewertung"},
            {title: "Dividende"},
            {title: "Technische Indikatoren (Wertentwicklung)"},
            {title: "Wachstumraten (G&V)"},
            {title: "Wachstumsraten (Bilanz)"},
            {title: "Wachstumsraten (Cashflow)"},
            {title: "Profitabilität"},
            {title: "Liquidität"},
            {title: "Aktivität"},
            {title: "Verschuldung"}*/]
        },
        {
          assetClassId: 'SHARE_ETF',
          extendedViewViewDropdown: [
            {title: "Überblick"}/*,
            {title: "Kurzfristige Wertentwicklung"},
            {title: "Langfristige Wertentwicklung"},
            {title: "Portfolio"},
            {title: "Risiko"}*/]
        },
        {
          assetClassId: 'CORPORATE_BONDS_ETF',
          extendedViewViewDropdown: [
            {title: "Überblick"},/*
            {title: "Kurzfristige Wertentwicklung"},
            {title: "Langfristige Wertentwicklung"},
            {title: "Portfolio"},
            {title: "Risiko"}*/]
        },
        {
          assetClassId: 'GOVERNMENT_BONDS_ETF',
          extendedViewViewDropdown: [
            {title: "Überblick"},/*
            {title: "Kurzfristige Wertentwicklung"},
            {title: "Langfristige Wertentwicklung"},
            {title: "Portfolio"},
            {title: "Risiko"}*/]
        },
        {
          assetClassId: 'COMMODITIES_ETF',
          extendedViewViewDropdown: [
            {title: "Überblick"},/*
            {title: "Kurzfristige Wertentwicklung"},
            {title: "Langfristige Wertentwicklung"},
            {title: "Portfolio"},
            {title: "Risiko"}*/]
        }
      ],
      extendedView: false,
      resolver: this.getTableData,
      activeEtfFilters: [],
    }
  },
  computed: {
    extendedViewViewDropdown() {
      let assetClassitem = this.assetClassDropdownMapping.find(item => item.assetClassId === this.assetClassId)
      return assetClassitem?.extendedViewViewDropdown
    },
    dropdownHeight() {
      // TODO
      return "50vh"
    },
    headers() {
      return TablePresets.createStrategyDataTableHeaders(this.assetClassId, this.extendedView, this.viewType[0],
        this.showInstrumentProfileAs)
    },
    hideCrypto() {
      return this.$route.path.includes('/onboarding')
    },
    hideFilter() {
      // Onboarding and finStrategist share the same behavior: always apply the filter, display based on extendedView property
      if (this.$route.path.includes('/onboarding') || this.$route.path.includes('/finStrategist')) {
        return !this.extendedView
      }
      // FinStrategy: always show the filter
      if (this.$route.path.includes('/finStrategy') && !this.$route.path.includes('/finStrategist')) {
        return false
      }
      // MyFinHub (Portfolio->AddToPortfolio): always show the filter
      if (this.$route.path.includes('/myFinHub')) {
        return false
      }
      return false
    }
  },
  mixins: [SubscriptionHandler],
  methods: {
    async getTableData(options) {
      if (options) {
        let {sortBy, sortDesc, page, itemsPerPage, sortByHeader} = options
        if (!sortBy || sortBy.length <= 0) {
          sortBy = ["finScore"]
          sortDesc = [true]
          sortByHeader = [{}]
        }
        let filter = {strategyId: {eq: this.strategy.id}}

        let shareUniverseFilter = ''
        if (this.assetClassId === 'SHARE') {
          shareUniverseFilter = this.buildShareUniverseFilter(this.shareUniverse)
          filter = Object.assign(filter, shareUniverseFilter)
        } else {
          filter = etfFilterBuilder.buildEtfFilter(this.activeEtfFilters, this.strategy.id)
        }

        if(this.hideCrypto) {
          const cryptoFilter = Cryptocurrencies.items.map(item => {
            return {fin_strategy: {eq: item}}
          })
          filter.filterCriteria = {not:{or: cryptoFilter}}
        }
        //TODO add this after consistent searchqueries to the Datatable or/and Util
        //TODO support multisort
        //Transform SortString to SortObject
        const sortObj = createPath({}, sortBy[0],
          (sortByHeader[0].keywordSort ? 'keyword_' : '') + (sortDesc[0] ? 'desc' : 'asc'))

        const params = {
          filter: filter,
          from: (page - 1) * itemsPerPage,
          limit: itemsPerPage,
          sort: sortObj
        }

        let data = null
        try {
          data = await finInstrumentAPI.searchStrategyInstruments(params)
        } catch (error) {
          console.error("StrategyInstrumentsDataTable: error calling searchStrategyInstruments(params)", params, error)
          data = {items: [], total: 0}
        }

        // to display the number of instruments in the calling component
        this.$emit("nbOfQualifiedInstruments", data ? data.total : 0)

        if (page !== this.currentPage) {
          this.currentPage = page
          if (this.realtime) {
            this.unsubscribeChanges()
            this.subscribeToChanges(
              data.items,
              strategyDetailsInstrumentSubscription,
              (strategyItem) => {
                return {id: strategyItem.instrumentId}
              },
              this.handleInstrumentSubscription
            )
          }
        }

        return data
      } else {
        return undefined
      }
    },
    handleInstrumentSubscription(newData, strategyItem) {
      const {price, timestamp, priceChange, priceChangePercentage, high, low, id} = newData.data.onCreateRealTimePrice
      const tableCompRef = this.$refs.finDataTable
      const vTableRef = tableCompRef.$refs.table

      if (vTableRef) {
        const item = vTableRef.items.find(i => i.instrumentId === id)

        if (item) {
          item.instrument.latestPrice = newData.data.onCreateRealTimePrice
          item.instrument.close = price
          item.instrument.closeChange1D = priceChangePercentage
          item.instrument.closeChangeAbsolute1D = priceChange
          item.instrument.closeDate = timestamp
          item.instrument.high = high
          item.instrument.low = low

          tableCompRef.recalculateModel()
        }
      }
    },
    buildShareUniverseFilter(shareUniverse) {
      let selectedUniverse = shareUniverse ? shareUniverse[0] : undefined
      let filter =
        selectedUniverse && selectedUniverse.id === 'OECD' ? {instrument: {isOECD: {eq: true}}} :
          selectedUniverse && selectedUniverse.id === 'BlueChip' ? {instrument: {isBlueChip: {eq: true}}} :
            selectedUniverse && selectedUniverse.id === 'EU' ? {instrument: {isEU: {eq: true}}} :
              selectedUniverse && selectedUniverse.id === 'DE' ? {instrument: {country: {id: {eq: 'DE'}}}} :
                undefined
      return filter
    },
    selectItem(selectedItem) {
      if (selectedItem && this.isSelected(selectedItem.id)) {
        this.selected = this.selected.filter((value) => {
          return value.id !== selectedItem.id
        })
      } else {
        this.selected.push(selectedItem)
      }
    },
    isSelected(id) {
      let result = this.selected.find(entry => {
        return entry.id === id
      })
      if (result) {
        return true
      } else {
        return false
      }
    }
  }
  ,
  watch: {
    selected() {
      this.$emit('input', this.selected)
    }
    ,
    strategy: {
      handler() {
        this.resolver = (options) => this.getTableData(options)
      }
      ,
      deep: true
    }
    ,
    shareUniverse() {
      this.resolver = (options) => this.getTableData(options)
    }
    ,
    activeEtfFilters() {
      this.resolver = (options) => this.getTableData(options)
      this.$emit('extendedViewChanged')
    }
    ,
    extendedView() {
      this.$emit('extendedViewChanged')
    }
    ,
  }
}
</script>

<style lang="scss" scoped>

@import "../../../styles/variables";

.switch {
  margin-top: 0;
}

// v-switch
::v-deep .theme--light.v-input--switch .v-input--switch__track {
  background-color: white;
  border: 2px solid #a9b0b4;
  opacity: 1 !important;

  &.primary--text {
    background-color: $fin-color-primary-dark;
    border: 0;
  }
}

::v-deep .theme--light.v-input--switch .v-input--switch__thumb {
  color: #a9b0b4 !important;
  caret-color: #a9b0b4 !important;

  &.primary--text {
    color: white !important;
    caret-color: white !important;
  }
}
</style>
